var render, staticRenderFns
import script from "./BarChartMonth.vue?vue&type=script&lang=js&"
export * from "./BarChartMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BarChartMonth.vue"
export default component.exports